import { render, staticRenderFns } from "./ReturnPaymentPlanRecords.vue?vue&type=template&id=68d3712c&scoped=true"
import script from "./ReturnPaymentPlanRecords.vue?vue&type=script&lang=js"
export * from "./ReturnPaymentPlanRecords.vue?vue&type=script&lang=js"
import style0 from "./ReturnPaymentPlanRecords.vue?vue&type=style&index=0&id=68d3712c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68d3712c",
  null
  
)

export default component.exports